import {
    Box,
    Button,
    CssBaseline,
    Paper,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { Table, Container, Row, Col } from 'react-bootstrap';

import React, { useRef, useState } from 'react';
import Pagination from '../../general/Pagination';
import ExportContent from '../../ExportContent';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import AppModal from '../../AppModal';
let Radiation;
export default function EnergyReportingLogTable({ radiationName, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const tableRef = useRef(null);

    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(15);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(TableData.length / recordsPerPage)

    if (TableData?.length > 0) {
        Radiation = TableData[0]
    }

    function genPDF() {
        const textX = 20; // Adjust the X-coordinate as needed
        const textY = 20; // Adjust the Y-coordinate as needed
        const logoWidth = 50; // Adjust the logo width as needed
        const logoHeight = 30; // Adjust the logo height as needed
        const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });

        // Add image dynamically
        const imgData = require('../../../assets/img/logos/logo 2.png');

        // Get the width of the PDF document
        const pdfWidth = pdf.internal.pageSize.getWidth();

        // Calculate the X-coordinate to center the logo
        const logoX = (pdfWidth - logoWidth) / 2;

        // Add table content using autotable
        pdf.setFontSize(12);
        // pdf.text('Solar PowerAmr', textX, textY);

        // Add the centered logo
        pdf.addImage(imgData, 'JPEG', logoX, textY + 5, logoWidth, logoHeight);

        // Add title centered on the page
        const title = ` ${radiationName} ${ValueOf2}`;
        const titleWidth = pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const titleX = (pdfWidth - titleWidth) / 2;

        pdf.text(title, titleX, textY + 5 + logoHeight + 10);

        pdf.autoTable({
            html: '#table-to-pdf',
            startY: textY + 5 + logoHeight + 20, // Adjust the Y-coordinate as needed
        });

        // Save or download the PDF
        pdf.save(`Daily Energy Log To ${ValueOf2} ${radiationName}.pdf`);
    }

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <CssBaseline />
            <Box component={Stack} rowGap={spacing(1)} sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <ExportContent
                    excelTableRef={tableRef.current}
                    onGenPdf={genPDF}
                    ExcelExportFileName={`Daily Energy Log To ${ValueOf2} ${radiationName}`}
                    title={radiationName}
                    onFullScreen={handleOpen}
                    filterContent={
                        <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <input type='date' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
                            <Typography variant='body1' >To</Typography>
                            <input type='date' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
                            <Button onClick={onRefreshData} variant='contained' sx={{  p: 0, m: 0, fontSize: '12px',  borderRadius: borderRadius }}>Show</Button>
                        </Box>

                    }
                />
                {
                    currentRecords?.length > 0 ? <>


                        {/* TableContainer for making the table responsive */}

                        <div>
                            <Table style={{}} id='table-to-pdf' striped bordered hover responsive>
                                <thead style={{}}>
                                    <tr style={{ textAlign: 'center' }}>
                                        {
                                            TableHead?.map((item, index) => {
                                                return (
                                                    <th style={{ padding: 15, whiteSpace: 'nowrap', backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentRecords?.map((item, index) => {
                                            // console.log('data', item)
                                            return (
                                                <tr key={index}>
                                                    {TableHead.map(key =>
                                                        <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
                                                    )}
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>


                        </div>

                        {/* Pagination */}
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Pagination nPages={nPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                        </Box>

                        {/* AppModal */}
                        <AppModal open={open} handleClose={handleClose}></AppModal>



                    </>

                        : <>
                            <Typography variant='body2' color={'error.main'} textAlign={'center'}>Data Not Found</Typography>
                        </>
                }

            </Box>
        </>
    )
}
